/**
 * Created by ChrisMuto on 7/7/17.
 */
import { isNil } from "lodash";

export function getImageById(entities, imageId) {
    const { images } = entities;
    if (isNil(images)) {
        return null;
    }
    return images[imageId];
}



// WEBPACK FOOTER //
// ./src/modules/images/selectors.js